import { loader } from 'graphql.macro'

export default function invoicesAmountSummary ({ dataLoaders, queryKey }) {
  const [,
    haulerId,
    invoiceNumber = null,
    accountName = null,
    status = null,
    startDate = null,
    endDate = null
  ] = queryKey

  const summarySchema = loader('./invoicesAmountSummary.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(summarySchema, {
    haulerId,
    invoiceNumber,
    accountName,
    status,
    startDate,
    endDate
  })
}
